export const storyTags = ({dispatch}) => next => (action) => {
    next(action);
}
